import { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import useAxios from "../../../../Utils/useAxios";
import {
  InputField,
  NumberInputField,
  SelectionField,
  TimeInputField,
} from "../../../../CommonElements";
import createGroupStaf from "../services/createGroupStaf";
import updateGroupStaf from "../services/updateGroupStaf";
import getUnitKerja from "../services/getUnitKerja";
import { Controller, useForm } from "react-hook-form";

const  GroupStafForm = ({ resetState, toggle, data }) => {
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const axiosInstance = useAxios();

  const [unitKerja, setUnitKerja] = useState([]);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      getUnitKerjaUR();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const getUnitKerjaUR = () => {
    getUnitKerja(axiosInstance).then((res) => setUnitKerja(res.data));
  };

  const createUserRole = (data) => {
    createGroupStaf(axiosInstance, data).then(() => {
      resetState();
      toggle();
    });
  };

  const editUserRole = (data) => {
    updateGroupStaf(axiosInstance, data.id_group, data).then(() => {
      resetState();
      toggle();
    });
  };

  return (
    <Form
      onSubmit={
        data ? handleSubmit(editUserRole) : handleSubmit(createUserRole)
      }
    >
      <Controller
        name="nama"
        control={control}
        rules={{ required: "Harap masukkan nama group staf" }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Group"}
            defaultValues={data?.nama}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="max_cuti"
        control={control}
        rules={{ required: "Harap masukkan maksimal cuti" }}
        render={({ field, fieldState }) => (
          <NumberInputField
            label={"Maksimal Cuti"}
            defaultValues={data?.max_cuti}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="jam_masuk"
        control={control}
        render={({ field, fieldState }) => (
          <TimeInputField
            label={"Jam Masuk"}
            defaultValue={data?.jam_masuk ?? "08:00:00"}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="jam_keluar"
        control={control}
        render={({ field, fieldState }) => (
          <TimeInputField
            label={"Jam Keluar"}
            defaultValue={data?.jam_keluar ?? "17:00:00"}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="id_unit_kerja"
        control={control}
        rules={{ required: "Harap pilih unit kerja" }}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"DPSJ"}
            placeholder={"-- select unit --"}
            defaultValues={data?.id_unit_kerja}
            options={unitKerja.map((row) => ({
              id: row.nama_unit_kerja,
              name: row.nama_unit_kerja,
            }))}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="pimpinan"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Pimpinan"}
            defaultValues={data?.pimpinan}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="asal_absensi"
        control={control}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Asal Absensi"}
            placeholder={"-- select asal absensi --"}
            defaultValues={data?.asal_absensi}
            options={[
              {
                id: 1,
                name: "1 - Finger",
              },
              {
                id: 2,
                name: "2 - Satpam",
              },
              {
                id: 3,
                name: "3 - Finger dan Satpam",
              },
            ]}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="email_pimpinan"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Email Pimpinan"}
            defaultValues={data?.email_pimpinan}
            fieldState={fieldState}
            {...field}
          />
        )}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default GroupStafForm;
